class StickyHeader extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.isTicking = false
    this.lastKnownY = window.scrollY
    this.safeZone = 30

    this.setLogoHeight()
  }

  setupListeners () {
    super.setupListeners()

    this.requestTick = this.requestTick.bind(this)
    this.updateEl = this.updateEl.bind(this)
    this.onScroll = this.onScroll.bind(this)
    this.setLogoHeight = this.setLogoHeight.bind(this)

    window.addEventListener('scroll', this.onScroll, { passive: true })

    window.addEventListener('resize', this.setLogoHeight, { passive: true })

    if (!this.els?.link?.exists) return

    this.onHeaderHover = this.onHeaderHover.bind(this)

    this.listeners.add(document, 'pointermove', this.onHeaderHover)
    this.listeners.add(document, 'focusin', this.onHeaderHover)
  }

  setLogoHeight () {
    document.documentElement.style.setProperty(
      '--Logo_Height',
      `${this.els.logo.element.offsetHeight}px`,
    )
  }

  onHeaderHover (event) {
    const hoveredLink = event.target.closest(this.els.link.selector)

    this.bodyElement.classList.toggle(
      this.bodyElement.dataset.hoverClass,
      !!hoveredLink,
    )
  }

  onScroll () {
    const previouslyKnown = this.lastKnownY

    this.lastKnownY = window.scrollY
    this.scrollDirection = previouslyKnown < this.lastKnownY ? 'down' : 'up'

    this.requestTick()
  }

  requestTick () {
    if (!this.isTicking) requestAnimationFrame(this.updateEl)

    this.isTicking = true
  }

  updateEl () {
    this.isTicking = false

    this.setScrolled()
    this.setScrolledUp()
  }

  setScrolled () {
    this.classList.toggle(this.dataset.classScrolled, this.hasScrolled)

    if (this?.externalEls?.hero?.exists) {
      this.externalEls.hero.element.setAttribute(
        'aria-hidden',
        this.hasScrolled,
      )
    }
  }

  setScrolledUp () {
    this.classList.toggle(this.dataset.classScrolledUp, this.hasScrolledUp)
  }

  get bodyElement () {
    return document.body
  }

  get hasScrolled () {
    return this.lastKnownY >= this.safeZone
  }

  get hasScrolledUp () {
    return this.scrollDirection === 'up' && this.lastKnownY >= this.safeZone
  }
}

if (!customElements.get('sticky-header')) {
  customElements.define('sticky-header', StickyHeader)
}
